<template>
  <div class="card card-user">
    <div class="card-body">
      <form>
        <div class="form-group row">
          <label class="col-md-2 col-form-label">Name</label>
          <div class="col-md-10">
            <input v-model="gameType.name" type="text" class="form-control">
          </div>
        </div>
        <div class="row">
          <div class="update ml-auto mr-auto">
            <button type="submit" class="btn btn-primary btn-round" @click="submit">送出</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GameTypeCreate',
  data: function() {
    return {
      gameType: {
        name: ''
      }
    }
  },
  mounted() {
  },
  methods: {
    submit: function() {
      this.$store.commit('CLOSE_LOADING')

      this.$store.dispatch('gameTypeCreate', { credentials: this.gameType }).then((res) => {
        if (!res.errorCode) {
          this.$store.commit('CLOSE_LOADING')

          this.$router.push({ name: 'GameType.List' })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
